import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { useContext, useEffect, useRef, useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import defaultImage from '../../assets/images/DefaultImage.png';
import { EditEvent, getEvents, getTheEvent } from '../../services/events/event';
import { useDispatch, useSelector } from 'react-redux';
import { setEventId, setIsPlanSelected } from '../../redux/search.slice';
import { GlobalDropDown } from '../../components/GlobalDropDown';
import { setLocalEventId } from '../../redux/search.slice';
import { ThemeContext } from '../../context/theme.context';
import { getPlan } from '../../services/ControlCenter/PlanServices';
import PlannedOperations from './PlannedOperations';

const formatOptions = 'dd/MM/yyyy';
let event_codeValue = -1;
let event_task = '';
let description = '';
let asset = '';
let equipment = '';
let duration = 0;
let planned_start_date = new Date('');
let planned_end_date = new Date('');
let scheduled_start_date = new Date('');
let scheduled_end_date = new Date('');
let actual_start_date = new Date('');
let actual_end_date = new Date('');
let compliance_date = new Date('');
let created_date = new Date('');
let tolerance = 0;
let event_planner = '';
let event_scheduler = '';
let event_supervisor = '';
let project_managerText = '';
let eventId: number = 0;
let isFirstRender3: boolean = true;
let planDropDown: DropDownListComponent | null;
let eventType: DropDownListComponent | null;
let projectManagerDropDown: DropDownListComponent | null;
let eventDropDown: DropDownListComponent | null;
const CloudExecutionManagement = () => {
  const [c_event_value, setC_EventValue] = useState<number>(-1);
  //const [isRenderSec3, setIsRenderSec3] = useState<boolean>(false);
  const [isRenderSec3, setIsRenderSec3] = useState<boolean>(true);
  const [projectManagerValue, setProjectManagerValue] = useState<number>();
  const [planDropdownText, setPlanDropdownText] = useState<string>('');
  const [planDropdownValue, setPlanDropdownValue] = useState<number>(0);
  const [eventTypeText, setEventTypeText] = useState<string>('');
  let reduxEventId = useSelector((state: any) => state.search.event_id);
  let local_event_id = useSelector((state: any) => state.search.local_event_id);
  const [eventValue, setEventValue] = useState<number>(local_event_id);
  const dispatch = useDispatch();


  let thePlanData: Array<any> = [];
  const context = useContext(ThemeContext);
  let thePlanID = Number(localStorage.getItem('cs_plan_dd_value')) ? Number(localStorage.getItem('cs_plan_dd_value')) : 0;
  let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
  const eventDropDownRef = useRef<DropDownListComponent | null>(null);
  const planDropDownRef = useRef<DropDownListComponent | null>(null);
  const [eventsData, setEventsData] = useState<Array<any>>([]);
  const [planData, setPlanData] = useState<Array<any>>([]);
  const [planValue, setPlanValue] = useState<number>(
    Number(localStorage.getItem('cs_plan_dd_value'))
  );


  const onChangeEvents = async (isFirst: boolean, args: any) => {
    localStorage.setItem('cs_event_dd_value', args.value);
    const eventId = args.value;
    await getPlans(eventId);
    const plan_id = thePlanData.length > 0 ? thePlanData[1]?.ID : null;
    if (eventId === -1) {
      localStorage.removeItem('cs_event_dd_value');
      localStorage.removeItem('cs_plan_dd_value');
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
      return;
    }
    if (thePlanData.length === 2 || args.isTheSavedPlan) {
      let thePlan = planData[1];
      if (args.isTheSavedPlan) {
        planDropDownRef.current &&
          (planDropDownRef.current.value = args.plan_id);
        await onChangePlan(isFirst, { value: args.plan_id });
        return;
      }
      if (plan_id !== null) {
        localStorage.setItem('cs_plan_dd_value', plan_id);
        planDropDownRef.current && (planDropDownRef.current.value = plan_id);
        setPlanValue(plan_id);
        context.setPlanId(plan_id);
        dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: plan_id,
          })
        );
        if (isFirst) {
          context.setResourcesAllowChange(true);
          context.setMaterialAllowChange(true);
        }
      }
    } else {
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
    }
  };
  const onChangePlan = async (isFirst: boolean, args: any) => {
    localStorage.setItem('cs_plan_dd_value', args.value);
    if (-1 === args.value) {
      localStorage.removeItem('cs_plan_dd_value');
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    } else {
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: args.value,
        })
      );
      context.setPlanId(args.value);
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    }
  };
  const getPlans = async (event_id: Number) => {
    await getPlan(event_id).then((res: any) => {
      res.data.unshift({
        plan_name: '',
        ID: -1,
      });
      thePlanData = res.data;
      setPlanData(res.data);
    });
  };
  const getEvent = async () => {
    await getEvents().then((result) => {
      result.data.unshift({
        eventCode: '',
        eventId: -1,
      });

      setEventsData(result.data);
    });
  };

  const fetchData = async () => {
    await getEvent();
    if (theEventID !== 0 && thePlanID !== 0) {
      if (eventDropDownRef && eventDropDownRef !== null)
        eventDropDownRef.current &&
          (eventDropDownRef.current.value = theEventID);
      setPlanValue(thePlanID);
      onChangeEvents(false, {
        value: theEventID,
        plan_id: thePlanID,
        isTheSavedPlan: true,
      });
    } else {
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
    }
  };

  useEffect(() => {
    $('.collapse-first').click(function () {
      $('.firstEM').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement').toggleClass('rotateIcon-event');
    });
    $('.collapse-second').click(function () {
      $('.second').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement2').toggleClass('rotateIcon-event');
    });
    $('.collapse-three').click(function () {
      $('.threeEM').toggleClass('show-content-event');
      $('#rotate-icon-eventmanagement3').toggleClass('rotateIcon-event');
    });
    $('.collapse-four').click(() => {
      if (event_codeValue === -1) {
        //
      }
      if (isFirstRender3) {
        setIsRenderSec3(true);
      } else {
        $('.four').toggleClass('show-content-event');
        $('#rotate-icon-eventmanagement4').toggleClass('rotateIcon-event');
      }
      isFirstRender3 = false;
    });

    fetchData();
    return () => {
      $('.collapse-first').off('click');
      $('.collapse-second').off('click');
      $('.collapse-three').off('click');
      $('.collapse-four').off('click');
      context.setPlanId(0);
    };
  }, []);
  useEffect(() => {
    var eventidLocalStorage = localStorage.getItem('Event_Id') ?? '';
    setEventValue(() => parseInt(eventidLocalStorage));
    if (reduxEventId !== 0) {
      setInputs(reduxEventId);
    } else if (reduxEventId === 0) {
      setInputs(local_event_id);
    }
    isFirstRender3 = true;
  }, [reduxEventId]);

  useEffect(() => {
     fetchData();
  }, [thePlanID]);

  const OnchangeEvent = (args: any) => {
    dispatch(setEventId(args.target.value));
    dispatch(setLocalEventId(args.target.value));

    let event_id = args.target.value;
    eventId = event_id;
    setInputs(event_id);
    setEventId(args.target.value);
  };
  const setInputs = async (eventId: any) => {
    const eventData = (await getTheEvent(eventId)).data;
    dispatch(setEventId(0));
    eventId = eventId;

    scheduled_start_date = new Date(eventData?.scheduledStartDate);

    if (eventData) {
      setEventTypeText(eventData?.type);
      tolerance = eventData.tolerance;
      // setPlanDropdownText(eventData?.status);

      if (eventData.eventId !== undefined) {
        localStorage.setItem('Event_Id', eventData.eventId);
        setEventValue(() => eventData?.eventId);
      }
      setC_EventValue(eventId);
      setProjectManagerValue(eventData?.customNumberField1);
    }
  };

  const itemProjectManagerTemplate = (args: any) => {
    var location = window.location.href;
    try {
      var imageUrl = require(`${location}static/media/people/` +
        args.image_url);
      return (
        <div className='project-manager-control-itemsImage'>
          <span className='project-mager-image'>
            <img src={imageUrl} alt='Person' />
          </span>
          <span className='col-md-9'>
            {args.firstName + ' ' + args.lastName}
          </span>
        </div>
      );
    } catch (err) {
      return (
        <div className='project-manager-control-itemsImage'>
          <span className='project-mager-image'>
            <img src={defaultImage} alt='Person' />
          </span>
          <span className='col-md-9'>
            {args.firstName + ' ' + args.lastName}
          </span>
        </div>
      );
    }
  };
  return (
    <div className=' content-EventManagement'>
      <div className='eventmanagement-sub-content'>
        <div className='collapse-parent-div'>
          {/* <div className='collapse-sub-flex collapse-first'>
            <div className='collapse-icon-div collapse-flex'>
              <FiChevronDown
                id='rotate-icon-eventmanagement'
                className='rotateIcon-event'
                size={17}
              />
            </div>
          </div> */}
          <div className='firstEM'>
            <div className='col-lg-4'>
              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-lg-4'>
                    <DropDownListComponent
                      placeholder='Event'
                      ref={eventDropDownRef}
                      dataSource={eventsData}
                      fields={{ text: 'eventCode', value: 'eventId' }}
                      onChange={onChangeEvents.bind(this, true)}
                      value={theEventID}
                    />
                  </div>
                  <div className='col-lg-4'>
                    <DropDownListComponent
                      ref={planDropDownRef}
                      placeholder='Plan'
                      dataSource={planData}
                      value={planValue}
                      fields={{ text: 'plan_name', value: 'ID' }}
                      onChange={onChangePlan.bind(this, true)}
                    />
                  </div>
                </div>
                <div className='row'>

                </div>
              </div>
            </div>
            <div className='col-lg-5'>
              <div className='col-lg-4'></div>

              <div className='col-lg-4'>
                <DatePickerComponent
                  id='scheduledStart'
                  style={{ height: 25 }}
                  placeholder='Scheduled Start'
                  format={formatOptions}
                  value={scheduled_start_date}
                  onChange={(e: any) => {
                    scheduled_start_date = e.target.value;
                  }}
                  floatLabelType='Auto'
                />
              </div>



            </div>

            <div className='col-lg-3'>
              <div className='col-lg-6 p-0'>

              </div>
            </div>
          </div>
        </div>
        <div className='collapse-parent-div '>
          <div className='collapse-sub-flex collapse-four'>
            <div className='collapse-icon-div-four collapse-flex'>
              <FiChevronDown id='rotate-icon-eventmanagement4' size={17} />
            </div>
          </div>
          {true ? (
            <div className='four show-content-event'>
              <div style={{marginTop:32}}>
                <label style={{ fontSize: '18px' }}>PLANNED OPERATIONS</label>
                <PlannedOperations plan_id={thePlanID} />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default CloudExecutionManagement;
